import ClientViewPageSettingsButtonMapping from './components/button-mapping';
import ClientViewPageSettingsStartGame from './components/start-game';

function ClientViewPageSettings({visible, setVisible}) {
    const handleClose = () => {
        setVisible(false)
    }

    return (
        <>
            {visible === true &&
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                    <div className="w-[90%] bg-white dark:bg-[#111a22] rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-slate-200 dark:border-slate-800 overflow-hidden relative">
                        <button onClick={() => handleClose()} className="absolute top-4 right-4 z-10 text-white/70 hover:text-white transition-colors">
                            <span className="material-symbols-outlined">close</span>
                        </button>

                        <div className="h-[60px] bg-primary relative overflow-hidden">
                            <div className="absolute inset-0 opacity-20" style={{backgroundImage: "linear-gradient(45deg, #000 25%, transparent 25%, transparent 50%, #000 50%, #000 75%, transparent 75%, transparent)", backgroundSize: "20px 20px"}}></div>
                            <div className="absolute inset-0 bg-gradient-to-t from-[#111a22] to-transparent"></div>
                        </div>

                        <div className="p-6 pt-3 relative flex flex-col z-[99]">
                            <div className="flex flex-col mb-[25px] gap-1">
                                <h3 className="text-[30px] font-bold text-slate-900 dark:text-white font-display">Client Settings</h3>
                                <p>Configure your racing credentials and data synchronization preferences.</p>
                            </div>
                            
                            <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" id="general">
                                <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">Button Mapping</h3>

                                <div className="p-6 flex flex-col gap-[10px]">
                                    <ClientViewPageSettingsButtonMapping />

                                    {window.pywebview?.api?.change_start_setting && (
                                        <ClientViewPageSettingsStartGame />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}


export default ClientViewPageSettings;